// Cancel.js
import React from 'react';

const Cancel = () => (
    <div>
        <h1>Payment Cancelled</h1>
    </div>
);
export default Cancel;